import { useEffect, useState } from 'react';
import axios from 'axios';
import { API_BASE_URL } from '../../../config/ApiConfig';
import LoadingModal from '../modals/LoadingModal';
import Pagination10 from '../Pagination10';
import useDefaultModal from '../hooks/useDefaultModal';
import DefaultModal from '../modals/DefaultModal';
import usePagination10 from '../hooks/usePagination10';

function AssociacoesFindModal({ show, onHide, onSelect }) {
  const [Associacoes, setAssociacoes] = useState([]);
  const [filtro, setFiltro] = useState('');
  const token = localStorage.getItem('token');
  const [isLoading, setLoading] = useState(true);
  const { setDefaultModal, showDefaultModal } = useDefaultModal();

  useEffect(() => {
    if (show && token) {
      setLoading(true);
      axios
        .get(`${API_BASE_URL.ASSOCIACAO}/all`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then(result => {
          console.log('Dados recebidos:', result.data);
          setAssociacoes(result.data);
        })
        .catch(error => {
          console.error('Erro ao obter associacoes:', error);
          showDefaultModal('error', 'Erro ao carregar associações.');
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [show, token]);

  // Função para selecionar associação
  const handleSelectAssociacao = associacao => {
    onSelect(associacao);
    onHide();
  };

  // Função para filtrar as associações com base na busca
  const normalizeString = str => {
    if (!str || typeof str !== 'string') return '';
    return str
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toUpperCase();
  };

  const associacoesFiltrados = Array.isArray(Associacoes)
    ? Associacoes.filter(c => {
        if (!c) return false;
        const normalizedBusca = normalizeString(filtro);
        return (
          normalizeString(c.nome || '').includes(normalizedBusca) ||
          normalizeString(c.cnpj || '').includes(normalizedBusca) ||
          normalizeString(c.municipio || '').includes(normalizedBusca) ||
          normalizeString(c.logrCidade || '').includes(normalizedBusca)
        );
      })
    : [];

  // Paginação dos associacoes filtrados
  const totalItems = associacoesFiltrados.length;
  const { setPagination } = usePagination10(totalItems);
  const selectedAssociacoes = associacoesFiltrados.slice(
    setPagination.startIndex,
    setPagination.startIndex + setPagination.rowsPerPage
  );

  if (!show) return null;

  return (
    <>
      <div
        className="modal show d-block"
        tabIndex="-1"
        style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div
              className="modal-header bg-success text-white"
              style={{ height: '30px' }}
            >
              <h5 className="modal-title mb-0">
                <i className="bi bi-building me-2"></i>
                Selecionar Associação
              </h5>
              <button
                type="button"
                className="btn-close btn-close-white"
                onClick={onHide}
              ></button>
            </div>

            <div className="modal-body small">
              {/* Campo de Filtro */}
              <div className="mb-3">
                <div className="input-group input-group-sm">
                  <span className="input-group-text">
                    <i className="bi bi-search"></i>
                  </span>
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    placeholder="Buscar por CNPJ, Nome ou Cidade"
                    value={filtro}
                    onChange={e => setFiltro(e.target.value.toUpperCase())}
                    style={{ textTransform: 'uppercase' }}
                  />
                </div>
              </div>

              <LoadingModal loading={isLoading} />

              {/* Tabela de Associações */}
              <div
                className="table-responsive shadow-sm"
                style={{ height: '400px', overflowY: 'auto' }}
              >
                <table className="table table-hover table-striped table-sm">
                  <thead className="table-secondary sticky-top">
                    <tr>
                      <th scope="col" className="px-2 d-none d-md-table-cell">
                        CNPJ
                      </th>
                      <th scope="col" className="px-2">
                        Nome
                      </th>
                      <th scope="col" className="px-2">
                        Cidade
                      </th>
                      <th scope="col" className="px-2">
                        UF
                      </th>
                      <th scope="col" className="px-2 text-center">
                        Ação
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {!isLoading &&
                      selectedAssociacoes.map(c => (
                        <tr
                          key={c.cnpj}
                          style={{ cursor: 'pointer' }}
                          onClick={() => handleSelectAssociacao(c)}
                          className="hover-row"
                        >
                          <td className="px-2 d-none d-md-table-cell">
                            {c.cnpj || ''}
                          </td>
                          <td className="px-2">{c.nome || ''}</td>
                          <td className="px-2">{c.logrCidade || ''}</td>
                          <td className="px-2">{c.logrUf || ''}</td>
                          <td className="text-center px-2">
                            <button
                              className="btn btn-outline-primary btn-sm"
                              onClick={e => {
                                e.stopPropagation();
                                handleSelectAssociacao(c);
                              }}
                            >
                              <i className="bi bi-check-lg" />
                            </button>
                          </td>
                        </tr>
                      ))}

                    {!isLoading && selectedAssociacoes.length === 0 && (
                      <tr>
                        <td colSpan="5" className="text-center text-muted py-3">
                          <i className="bi bi-info-circle me-2"></i>
                          Nenhuma associação encontrada.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>

              {/* Paginação */}
              {selectedAssociacoes.length > 0 && (
                <div className="mt-3">
                  <Pagination10 {...setPagination} />
                </div>
              )}

              <div className="d-flex justify-content-end gap-2 mt-3">
                <button
                  type="button"
                  className="btn btn-secondary btn-sm"
                  onClick={onHide}
                >
                  <i className="bi bi-x-lg me-1"></i>
                  Cancelar
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <DefaultModal {...setDefaultModal} />

      <style jsx>{`
        .hover-row:hover {
          background-color: var(--bs-primary-bg-subtle) !important;
        }
      `}</style>
    </>
  );
}

export default AssociacoesFindModal;
